export const readFileAsBinary = function (file) {
  return new Promise((resolve, reject) => {
    // Verificar si el archivo real está en originFileObj
    const actualFile = file.originFileObj || file

    if (!(actualFile instanceof Blob)) {
      reject(new TypeError("El parámetro debe ser un Blob o File"))
      return
    }

    const reader = new FileReader()
    reader.onload = () => {
      const binaryData = new Uint8Array(reader.result)
      resolve(binaryData)
    }
    reader.onerror = (error) => {
      reject(error)
    }
    reader.readAsArrayBuffer(actualFile)
  })
}

export function toIri(url, uuid) {
  if (url && uuid) return uuid.includes("/") ? uuid : `${url}/${uuid}`
}

export function toUuid(iri) {
  return iri.split("/").pop()
}

export function buildQueryString(params) {
  let _params = params

  const keys = Object.keys(_params).filter((value) => {
    return typeof _params[value] === "object"
      ? _params[value]?.length
      : _params[value] || typeof _params[value] === "number" || typeof _params[value] === "boolean"
  })
  let query = keys
    .map(function (key) {
      if (typeof _params[key] === "object") {
        return _params[key].map((val) => `${key}[]=${val}`).join("&")
      }

      return `${key}=${_params[key]}`
    })
    .join("&")

  return query
}
